import { Tag } from 'antd';
import type { VideoTranslationOutputDto } from '../model';

export function VideoTranslationOptionTags(props: {
  options:
    | Pick<
        VideoTranslationOutputDto,
        'remove_subtitles' | 'regenerate_subtitles' | 'regenerate_voice'
      >
    | undefined;
}) {
  const { options } = props;

  return (
    <>
      {options?.remove_subtitles === true && <Tag>智能去字幕</Tag>}
      {options?.regenerate_voice === true && <Tag>重新生成配音</Tag>}
      {options?.regenerate_subtitles === true && <Tag>压制字幕</Tag>}
    </>
  );
}
